import type { representativeList } from './types'
// // import { getResponse } from "@/service/utils";
// // import { getEnvConfig } from "@/service/config/UrlConfig";
import representativeData from '../../data/representativeList.json'

export class representativeService {
  async representativeList(
    clientId: number,
    representantiveType: number,
    currentPage: number,
    rowPage: number,
  ): Promise<{
    data: representativeList[];
    total: number;
  }> {
    // Filtrado
    const filtered = representativeData.data.filter(
      (representative: { clientId: number; representantiveType: number }) =>
        representative.clientId === clientId && representative.representantiveType === representantiveType,
    );

    // Total antes de paginar
    const total = filtered.length;

    // Paginación
    const start = currentPage * rowPage;
    const end = start + rowPage;
    const paginated = filtered.slice(start, end);

    return {
      data: paginated,
      total,
    };
  }

}
